import { useDynamicContentContext, useFormContext } from '../../contexts';

export const useSubmit = () => {
  const { handleSubmit } = useFormContext();
  const { insert } = useDynamicContentContext();
  return handleSubmit(({ conditionalContent }) => {
    if (conditionalContent) insert(conditionalContent);
  });
};
